module.exports = __webpack_public_path__ + "static/img/cha-lr-2.01840f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-lr-2.png
// module id = h1ox
// module chunks = 1